import * as Yup from 'yup';
import { getRequiredText } from '../../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { NewHireProps } from '../../../models/arc-epi-props';
import { PensionEnrollmentPlan } from '../../pension-enrollment/models/pension-enrollment-model';

export interface PensionPlanDetail {
	billingAccountType: string,
	type: string,
	amount: number,
}

export interface PensionEnrollmentFormValues {
	selectedPlans: string[];
}


export enum BenefitEnrollmentStep {
	PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
	RELATIONSHIP = 'RELATIONSHIP',
	PENSION = 'PENSION',
	RETIREMENT = 'RETIREMENT',
	COVERAGE = 'COVERAGE',
	REVIEW = 'REVIEW',
	EMPLOYMENT = 'EMPLOYMENT',
}

export enum ExcludedPensionID {
	LAY_DB_PENSION_PLAN_ID = 'PLayDBBase',
	CLERGY_DB_PENSION_PLAN_ID = 'PClergyDBBase',
}

export function GetNewHirePensionEnrollmentValidationSchema(settings: NewHireProps, labelSettings: LabelSettingProps, plansAvailable: PensionEnrollmentPlan[]) {
	if (!(plansAvailable?.length > 0)) {
		return null;
	}

	const shape: any = {
	};


	plansAvailable?.forEach(plan => {
		shape[`billingAccountType${plan.plan_id}`] = Yup.string().nullable().ensure()
			.when(['selectedPlans'], {
				is: (selectedPlans: string[]) => {
					return selectedPlans?.includes(`${plan?.plan_id}_${plan?.plan_type}`);
				},
				then: Yup.string().required(getRequiredText(labelSettings?.requiredFormat, settings?.billingAccountLabel)),
			});
		shape[`type${plan.plan_id}`] = Yup.string().nullable().ensure()
			.when(['selectedPlans'], {
				is: (selectedPlans: string[]) => {
					return selectedPlans?.includes(`${plan?.plan_id}_${plan?.plan_type}`) && plan?.pbpor_id !== ExcludedPensionID.LAY_DB_PENSION_PLAN_ID && plan?.pbpor_id !== ExcludedPensionID.CLERGY_DB_PENSION_PLAN_ID;
				},
				then: Yup.string().required(getRequiredText(labelSettings?.requiredFormat, settings.employeeContributionLabel)),
			});
		shape[`amount${plan.plan_id}`] = Yup.string().nullable().ensure()
			.when(['selectedPlans'], {
				is: (selectedPlans: string[]) => {
					return selectedPlans?.includes(`${plan?.plan_id}_${plan?.plan_type}`) && plan?.pbpor_id !== ExcludedPensionID.LAY_DB_PENSION_PLAN_ID && plan?.pbpor_id !== ExcludedPensionID.CLERGY_DB_PENSION_PLAN_ID;
				},
				then: Yup.string().required(getRequiredText(labelSettings?.requiredFormat, settings?.contributionLabel)),
			});

	});

	return Yup.object().shape(shape);
}